import React from "react";

import { Navigate, useLocation } from "react-router-dom";
import { getCurrentAuth } from "../../hooks/useAxiosPrivate";
import MainContainer from "../Component/MainContainer";
import PageRoutes from "../../utils/constants";

function PrivateRoutes({
  children,
  useV2Layout = false,
  v2Footer = false,
}: {
  children: React.ReactElement;
  useV2Layout?: boolean;
  v2Footer?: boolean;
}): React.ReactElement {
  const auth = getCurrentAuth();
  let location = useLocation();

  if (!auth?.AccessToken) {
    return (
      <Navigate
        to={PageRoutes.Login}
        state={{ from: location.pathname, search: location.search }}
        replace
      />
    );
  }

  if (useV2Layout) {
    return <>{children}</>;
  }

  return (
    <MainContainer v2Footer={v2Footer}>
      <>{children} </>
    </MainContainer>
  );
}

export default PrivateRoutes;
